import React from 'react';
import { useSelector } from 'react-redux';
import { useWorkersQuery } from '../../api/workers';
import Field from '../../shared/ui/Field';
import { useFieldController } from '../../../../helpers/formManager';
import DropdownSelect from '../../../../components/dropdownSelect';
import { createShortName } from '../../services/person';
import OptionContent from '../../shared/ui/OptionContent';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import { selectors, sliceKeys } from '../../model';

const { Option } = DropdownSelect;
const { selectCurrentId } = selectors[sliceKeys.companies];

const SelectAcceptanceWorkers = () => {
  const companyId = useSelector(selectCurrentId);
  const { data, isFetching } = useWorkersQuery({ params: { companyId } });

  const { field, fieldState } = useFieldController({
    name: fieldNames.main.workers,
  });

  return (
    <Field.Memoized
      type={Field.types.dropdownSelect}
      formItemLabel="Сотрудники"
      errorMessage={fieldState.error?.message}
      multiple
      loading={isFetching}
      value={field.value}
      onChange={field.onChange}
      label="Выбрать из списка"
    >
      {data?.map((worker) => {
        const shortName = createShortName(worker);
        const search = [worker.speciality, shortName].filter(Boolean).join('');

        return (
          <Option key={worker.id} value={worker.id} search={search}>
            <OptionContent title={worker.speciality} description={shortName} />
          </Option>
        );
      })}
    </Field.Memoized>
  );
};

export default SelectAcceptanceWorkers;
